import { useTranslation } from '@/core/hooks';
import { useMemo } from 'react';
import { getPropertyLabels } from '../constants/getPropertyLabels';

/**
 * Reactive property catalogue labels for web — backed by en/ar translations
 * (Contentful-aware via translationService) via getPropertyLabels.
 */
export function usePropertyLabels() {
  const { t } = useTranslation();
  return useMemo(() => getPropertyLabels(t), [t]);
}
